var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"radio-select",on:{"click":_setup.toggleSelect}},[(!_setup.props.isSelected)?_c('div',{staticClass:"radio-no-select"}):_c(_setup.Icon,{attrs:{"file":_setup.radioIcon,"size":'20px'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }